import Stack from '@mui/material/Stack'

export const SUB_HEADER_HEIGHT = '43.5px'

interface Props {
  children: React.ReactNode
}

export default function SubHeader({ children }: Props) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      padding="2rem"
      height={SUB_HEADER_HEIGHT}
      sx={theme => ({
        borderBottom: `0.2rem solid ${theme.palette.divider}`,
        backgroundColor: theme.colors.secondaryBackground,
      })}
    >
      {children}
    </Stack>
  )
}
